import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { RequerimientosService } from 'src/app/services/transacciones/requerimientos.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-requerimientos',
    templateUrl: './requerimientos.component.html',
    styleUrls: ['./requerimientos.component.scss'],
    standalone: false
})
export class RequerimientosComponent implements OnInit {
  title = 'datatables';
  dtOptions: DataTables.Settings = {};
  posts : any [] = [];
  public codigoDoctor: string = "";
  public nombreDoctor: string= "";
  public tipoEntrega: string= "";
  public idRequerimiento: string ="";
  public contador: Number = 0;
  public actualizarE: boolean = false;
  public textAreaObservacion: string = "";
  public observacion : string = "";
  public asesor: string = "";
  public tipo: string ="";
  public estado: string = "";
  private _usuario!: Usuario;
  public nombreUsuario: string = "";
  public orden = "";
  public textAreaObservacionPaciente: string = "";
  constructor(private ordenesService: OrdenesService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private  requerimientosService: RequerimientosService,
    private authService: AuthService,
    ) 
    
    {

      this._usuario = authService.loginUsuario;

      
  
     }

  public spinnerBoolean : boolean = false;
  ngOnInit(): void {
  
    this.spinnerBoolean =true;
    this.nombreUsuario = this._usuario.nombre!;
  
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[5, 'desc']],
      language: LanguageApp.spanish_datatables
    };


    /* -------------------------------------------------------------------------- */
    /*                        OBTENER TRANSACCIONES PAQUETE                       */
    /* -------------------------------------------------------------------------- */
    this.requerimientosService.obtenerRequerimiento("tomografia", "TIP_REQ", 'Tomografia', 'pendiente', 'vacio').subscribe((resp) => {
        this.posts = resp.rows;
     
   
        this.spinnerBoolean =false;

        
    });
   
  }

  consultarRequerimientos(estado, estadoTomo){
    this.posts = [];
    this.spinnerBoolean =true;
    this.requerimientosService.obtenerRequerimiento("tomografia", "TIP_REQ", 'Tomografia', estado, estadoTomo).subscribe((resp) => {
      this.posts = resp.rows;
   
 
      this.spinnerBoolean =false;

  });


  }

  /* -------------------------------------------------------------------------- */
  /*                         ABRIR MODAL ASIGNAR ENTREGA                        */
  /* -------------------------------------------------------------------------- */
  modalAsignarEntrega(basicModal:any, codigoDoctor, nombreDoctor, idRequerimiento, tipo, estado){

    this.modalService.open(basicModal);
    this.codigoDoctor = codigoDoctor;
    this.nombreDoctor = nombreDoctor;
    this.idRequerimiento = idRequerimiento;
    this.tipo = tipo;
    this.estado = estado;
  }


  /* -------------------------------------------------------------------------- */
  /*                       ABRIR MODAL ENVIAR NOTIFICACIO                       */
  /* -------------------------------------------------------------------------- */
  modalEnviarNotificacion(basicModal:any, observacion, asesor, idRequerimiento, tipo, estado){

    this.modalService.open(basicModal);
    this.observacion = observacion;
    this.asesor = asesor;
    this.idRequerimiento = idRequerimiento;
    this.tipo = tipo;
    this.estado = estado;

  }


  /* -------------------------------------------------------------------------- */
  /*                        ACTUALIZAR ESTADO TOMOGRAFÍA                        */
  /* -------------------------------------------------------------------------- */
  actualizarTomografia(){

    this.actualizarE =true;
    this.spinnerBoolean =  true;
    this.requerimientosService.actualizarEstado("actualizar-entrega",this.codigoDoctor, this.tipoEntrega, this.idRequerimiento).subscribe((resp) => {
      if(resp == "ok"){
        this.toastr.success('Ingrese la secuencia fisica', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.consultarRequerimientos(this.tipo, this.estado);
        this.actualizarE =false;
        this.spinnerBoolean =false;
        this.modalService.dismissAll();
      }else{

        this.actualizarE =false;
        this.spinnerBoolean =false;
      }
     

  });
  }


  /* -------------------------------------------------------------------------- */
  /*                             ENVIAR NOTIFICACION                            */
  /* -------------------------------------------------------------------------- */
  enviarNotificacion(){

    this.actualizarE =true;
    this.spinnerBoolean =  true;
    this.requerimientosService.enviarNotificacion(this.observacion,this.textAreaObservacion, this.asesor, this.idRequerimiento).subscribe((resp) => {
        if(resp == "ok"){

          this.toastr.success('Notificación enviada', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.consultarRequerimientos('pendiente', 'vacio');
          this.actualizarE =false;
          this.spinnerBoolean =false;
          this.modalService.dismissAll();
        }else{

          this.actualizarE =false;
          this.spinnerBoolean =false;
        }
    

    });
  }



  /* -------------------------------------------------------------------------- */
  /*                             ENVIAR NOTIFICACION                            */
  /* -------------------------------------------------------------------------- */
  modalEnviarNotificacionPaciente(basicModal:any, orden){
    this.modalService.open(basicModal);
    this.orden = orden;
  
  }


  enviarNotificacionPaciente(){

    this.actualizarE = true;
    this.spinnerBoolean = true;
    this.requerimientosService
      .enviarNotificacionPaciente(
        this.orden,
        this.textAreaObservacionPaciente
      )
      .subscribe({
        next: () => {
        this.toastr.success('Notificación enviada', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.consultarRequerimientos('Pendiente', 'entrega-paciente')
        this.actualizarE =false;
        this.spinnerBoolean =false;
        this.modalService.dismissAll();
        },
        error: (error) => {
          this.actualizarE = false;
          this.spinnerBoolean = false;
          this.toastr.error(
            error?.error?.message ||
              'No se pudo enviar la notificación al paciente',
            'Atención',
            {
              timeOut: 5000,
              closeButton: true,
              progressBar: true
            }
          );
        }
      });
  }

  
  /* -------------------------------------------------------------------------- */
  /*                            MARCAR COMO ATENDIDO                            */
  /* -------------------------------------------------------------------------- */
  marcarAtendido(fecha,usuario,idRequerimiento, tipo, estado){

    Swal.fire({
      icon: 'warning',
      title: '¿Está seguro de marcar como atendida esta tomografía?',
      text: 'si no lo está puede cancelar la acción!',
      showCancelButton: true,
      confirmButtonColor: '#0162e8',
      cancelButtonColor: '#FF0000',
      confirmButtonText: 'Si!',
      cancelButtonText: 'Cancelar',
      reverseButtons: true

    }).then((result) => {
      if (result.isConfirmed) {
        this.toastr.success('Procesando por favor espere...', 'Atención', {
          timeOut: 2000,
          closeButton: true,
          progressBar: true
        });
        
        this.requerimientosService.marcarAntendido(
          fecha,
          usuario,
        idRequerimiento,
        localStorage.getItem('token')
        ).subscribe((resp) => {
  
  
          if (resp == 'ok') {
            this.toastr.success('Marcando como atendido correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
            
          
            this.consultarRequerimientos(tipo, estado);
            
          }else{
  
            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
          
          }
  
        });
        
      
      }
    })
  }
}
export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}
